import './sass/index.scss';
//Check browser width for redirect to mobile
if (screen.width <= 768) {
    window.location.replace( '/assets/mobile.html' );
}

// /* LeadGenius Dashboard (Athena) */
require('./vendor');
import CONSTANTS from './constants';
window.loader = 0;
/* Bootstrapping Vue.js */
Vue.use(VueResource);
Vue.use(VueBootstrap);

/* Router bootstrapping */
import store from './base/store';
import application from './base/application.vue';
import prettyDate from './utils/pretty-date';
import router from './router';
import coolCookie from './cool-cookie';

Vue.http.options =  {
    root: `//${process.env.PREMIERE_URL}/api` || `//${process.env.VUE_APP_PREMIERE_URL}/api`,
    headers: {
        'Accept': 'application/json'
    },
    credentials: true
};

Vue.http.interceptors.push((request, next) => {
    const cookies = coolCookie.parse(document.cookie);
    request.headers.set('X-CSRFToken', cookies.csrftoken || cookies.sandbox_csrftoken);
    next();
});

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

if(process.env.PREMIERE_URL == 'leadgenius.com') {
    const VueAnalytics = require('vue-analytics');

    Vue.use(VueAnalytics, {
        id: 'UA-111728548-1',
        router,
        debug: {
            enabled: true,
            trace: true,
            sendHitTask: true
        }
    });
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

Vue.filter('capitalize', capitalize);
Vue.filter('prettyDate', prettyDate);
Vue.filter('percentage', function(num){
    return Math.round(num*100);
});
Vue.filter('round', function(num){
    return Math.round(num);
});

/* Directives */
Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.event = function (event) {
            // here I check that click was outside the el and his childrens
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.event)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.event)
    },
});

import {VueSelect} from 'vue-select';

import Nag from './components/Nag/Nag.vue';

/* Generic Components */
import extendedGrid from './components/extended-grid/extended-grid.vue';

/* Bootstrap components */
import booPagination from './components/bootstrap/pagination/pagination.vue';
import booGrid from './components/bootstrap/grid.vue';

Vue.component('v-select', VueSelect);

Vue.component('Nag', Nag);

/* Generic Components */
Vue.component('extended-grid', extendedGrid);

/* Bootstrap components */
Vue.component('boo-pagination', booPagination);
Vue.component('boo-grid', booGrid);

store
.dispatch('startSession')
.then(() => {
    const app = new Vue({
        store: store,
        render: (html) => html(application),
        router: router,
        computed: {
            session: session,
            urls: urls,
            production: production
        },
        created: function() {
            configureHttp.call(this);
        }
    });
    app.$mount('#application');
});


function configureHttp() {
    const self = this;

    Vue.http.interceptors.push((request, next) => {
        const noLoader = request.params && request.params.noLoader;
        if (!noLoader) {
            self.$store.commit('showLoader');
        }
        next(function (response) {
            if (!noLoader) {
                self.$store.commit('hideLoader');
            }
            return response;
        });
    });

    // Adds request to attribute to each response
    const requestInResponseInterceptor = (request, next) => {
        next(response => {
            response.request = request;
            return response;
        })
    }
    Vue.http.interceptors.push(requestInResponseInterceptor);

    /* key - key of response.body property to verify resolve
       value - value to compare for resolving
       intervalCallback - optional, will call after each iteration with response
     */
    Vue.http.poll = (url, delay, key, value, intervalCallback, params) => {
        let counter = 0;
        params = Object.assign({}, params, {noLoader: true});
        const call = (resolve, reject) => {
            ++counter;
            Vue.http.get(url, {params: params}).then((response) => {
                if (Array.isArray(value) ? value.includes(response.body[key]) : value === response.body[key]) {
                    return resolve(response.body);
                }
                const statuses = [CONSTANTS.POLLING_STATUSES.ERRED, CONSTANTS.POLLING_STATUSES.CANCELLED];
                if (statuses.includes(response.body.status)) {
                    return reject(response);
                }

                if (counter === 30) {
                    return reject({body: {message: 'Polling timeout error'}});
                }

                if (intervalCallback) {
                    intervalCallback(response.body);
                }
                setTimeout(() => {
                    call(resolve, reject);
                }, delay);
            }, (error) => {
                return reject(error);
            });
        };
        return new Promise((resolve, reject) => {
            call(resolve, reject);
        });
    }
}

function session() {
    return this.$store.state.session;
}

function production() {
    return this.$store.getters.production;
}

function loader() {
    return this.$store.state.loader;
}

function urls() {
    return {
        base: process.env.PREMIERE_URL,
    };
}
